import { defineComponent as _defineComponent } from 'vue'


// Components
import CloseButton from "@/vue/common/clsBtnV2.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentConditionPopup',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {

 

const handleClick = (): void => {
    emit("close")
}



return { __sfc: true,emit, handleClick, CloseButton }
}

})